// middleware/auth.ts
export default defineNuxtRouteMiddleware(async (to, from) => {
  const user = await getCurrentUser()
  if (!user && to.path !== '/login') {
    console.log('---middleware---');

    // Redirect to login with the intended path
    return navigateTo({
      path: '/login',
      query: {
        redirect: to.fullPath,
      },
    });
  } else if (user && to.path === '/login') {
    console.log('---middleware--- 1 ' + to.fullPath + "   " + from.fullPath);
    const redirectTo = to.query.redirect || '/';
    return await navigateTo(redirectTo.toString());
  }
})